var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"render-post",staticClass:"render-post-failed",style:({ fontSize: _vm.fontSize + 'px' })},[_c('i',{staticClass:"fa-regular fa-circle-exclamation"}),_c('p',[_vm._v(_vm._s(_vm.textError))])])}
var staticRenderFns = []

export { render, staticRenderFns }